export default {  
    SET_DLISTEXTERNAL: (state, payload) => state.dListExternal = payload,
  }